"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = void 0;
const Renderer_1 = __importDefault(require("./Renderer"));
exports.Renderer = Renderer_1.default;
exports.default = Renderer_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9SZW5kZXJlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7Ozs7QUFFL0IsMERBQWlDO0FBRXhCLG1CQUZGLGtCQUFRLENBRUU7QUFDakIsa0JBQWUsa0JBQVEsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbIi8vIENvcHlyaWdodCDCqSAyMDIxIE1vdmUgQ2xvc2VyXG5cbmltcG9ydCBSZW5kZXJlciBmcm9tICcuL1JlbmRlcmVyJ1xuXG5leHBvcnQgeyBSZW5kZXJlciB9XG5leHBvcnQgZGVmYXVsdCBSZW5kZXJlclxuIl19